import { DashboardPieChart } from "@aidkitorg/types/lib/admin-panel/dashboard";
import React, { useEffect, useState } from "react";
import { generateDistroSummaryKind } from "../../../utils/adminPanel.utils";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { BooleanExpr } from "@aidkitorg/types/lib/survey";
import { FilterGroupToBooleanExprConverter, BooleanExprToFilterGroupConverter } from "../../shared/utils/filterConverters";
import { useSettingsFilterFields } from "../../Filters/hooks/useSettingsFilterFields";

export const usePieChartFormState = (component?: DashboardPieChart) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [filterConfig, setFilterConfig] = useState<ReportFilterConfig | undefined>(undefined)
  const availableFieldsForFilters = useSettingsFilterFields()

  const [groupDataField, setGroupDataField] = useState('')
  const [aggregation, setAggregation] = useState('Count')
  const [dataField, setDataField] = useState('')

  useEffect(() => {
    if (!component) return

    const componentTitle = 'title' in component && component.title
      ? typeof component.title === 'string'
        ? component.title
        : component.title['en']
      : 'Dashboard Component';
    setTitle(componentTitle)
    setDescription(component.description || '')
    setAggregation(component.summary.kind)

    // Load filter config if present
    if (component.filter) {
      try {
        const filterGroup = BooleanExprToFilterGroupConverter.convert(component.filter, availableFieldsForFilters);
        if (filterGroup) {
          setFilterConfig({
            enabled: true,
            config: filterGroup
          });
        }
      } catch (error) {
        console.warn('Failed to convert pie chart filter to FilterConfig:', error);
      }
    }

    if (component.summary.kind === 'Sum' || component.summary.kind === 'Mean') {
      if (component.summary.value.kind === 'Field') {
        setDataField(component.summary.value.field)
      }
    }

    const groups = component.groups
    if (groups.length === 1 && groups[0].kind === 'Field') {
      setGroupDataField(groups[0].field)
    }
  }, [component])

  const buildPieChartObject = (): DashboardPieChart => {
    // Convert FilterConfig to BooleanExpr if filter is enabled
    let booleanExpr: BooleanExpr | undefined = undefined;
    if (filterConfig && filterConfig.enabled && filterConfig.config) {
      try {
        booleanExpr = FilterGroupToBooleanExprConverter.convert(filterConfig.config);
      } catch (error) {
        console.warn('Failed to convert filter config to boolean expression:', error);
      }
    }

    const pieChart: DashboardPieChart = {
      kind: 'Pie Chart',
      title: title,
      description: description,
      summary: generateDistroSummaryKind(aggregation,dataField),
      groups: [{
        kind: 'Field',
        field: groupDataField
      }],
      ...(booleanExpr && { filter: booleanExpr })
    }

    return pieChart
  }
  const isFormStateValid = title !== '' &&
    groupDataField !== '' &&
    (aggregation === 'Count' || dataField !== '')

  return {
    title, setTitle,
    description, setDescription,
    groupDataField, setGroupDataField,
    aggregation, setAggregation,
    dataField, setDataField,
    filterConfig, setFilterConfig,
    buildPieChartObject,
    isFormStateValid
  }
}